import React from 'react'
import { TicketStatusBadgeProps, TicketStatus } from './TicketStatusBadge.types'
import { useTranslation } from 'react-i18next'

// 4 base badge designs (no border on badges, border variables are for card top border)
const badgeStyles = {
  waiting:
    'bg-[var(--ticket-status-waiting-bg)] text-[var(--ticket-status-waiting-text)]',
  approved:
    'bg-[var(--ticket-status-approved-bg)] text-[var(--ticket-status-approved-text)]',
  cancelled:
    'bg-[var(--ticket-status-cancelled-bg)] text-[var(--ticket-status-cancelled-text)]',
  settled: 'active-gradient text-primary-950',
}

// Map all statuses to the 4 base designs
const badgeClassMap: Record<TicketStatus, string> = {
  [TicketStatus.WAITING]: badgeStyles.waiting,
  [TicketStatus.APPROVED]: badgeStyles.approved,
  [TicketStatus.WIN]: badgeStyles.approved,
  [TicketStatus.CANCELLED]: badgeStyles.cancelled,
  [TicketStatus.LOSE]: badgeStyles.cancelled,
  [TicketStatus.REJECTED]: badgeStyles.cancelled,
  [TicketStatus.SETTLED]: badgeStyles.settled,
  [TicketStatus.BET_FAILED]: badgeStyles.cancelled,
  [TicketStatus.ROUND_CANCELLED]: badgeStyles.cancelled,
  [TicketStatus.USER_CANCELLED]: badgeStyles.cancelled,
}

const TicketStatusBadge: React.FC<TicketStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation()
  return (
    <span
      className={`inline-flex items-center justify-center px-3 py-1.5 text-xs sm:text-sm font-medium rounded-full whitespace-nowrap ${badgeClassMap[status]}`}
    >
      {t(`pollStatus.${status}`)}
    </span>
  )
}

export default TicketStatusBadge
